/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ProdOrdFServ01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const prodOrdFServ01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prodOrdFServ01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const prodOrdFServ01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const prodOrdFServ01ImportLoading = (state, { boolean }) => ({
  ...state,
  importIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ProdOrdFServ01Types.PROD_ORD_F_SERV01_SHOW_SYNC_SETTING_LOADING]: prodOrdFServ01ShowSyncSettingLoading,
  [ProdOrdFServ01Types.PROD_ORD_F_SERV01_SHOW_SYNC_SETTING_SUCCESS]: prodOrdFServ01ShowSyncSettingSuccess,
  [ProdOrdFServ01Types.PROD_ORD_F_SERV01_SHOW_BATCH_JOB_STATUS_SUCCESS]: prodOrdFServ01ShowBatchJobStatusSuccess,
  [ProdOrdFServ01Types.PROD_ORD_F_SERV01_IMPORT_LOADING]: prodOrdFServ01ImportLoading
});
